export function isStringNullUndefinedOrEmpty(value: string): boolean {
  return isNullOrUndefined(value) || value.length === 0;
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function isStringNullUndefinedOrEmptyWithTrim(value: string): boolean {
  return isNullOrUndefined(value) || value.trim().length === 0;
}

export function hyphenatedYYYYMMDDToApiDate(date: string): string {
  if (isStringNullUndefinedOrEmpty(date)) {
    return '';
  }
  const dateSplit = date.split('-');
  const month = dateSplit[1].length === 1 ? '0' + dateSplit[1] : dateSplit[1];
  const day = dateSplit[2].length === 1 ? '0' + dateSplit[2] : dateSplit[2];
  const year = dateSplit[0];
  return month + '/' + day + '/' + year;
}

export const generateDateOfServiceRange = () => {
  const t = new Date();
  const range = {};

  for (let i = 1; i <= 12; i++) {
    const startOfMonth = new Date(t.getFullYear() - 1, t.getMonth() + i, 1);
    const end = new Date(t.getFullYear() - 1, (t.getMonth() + 1) + i, 0).getDate();
    const endOfMonth = new Date(t.getFullYear() - 1, t.getMonth() + i, end);
    const rangeStart = `${startOfMonth.getFullYear()}-${(startOfMonth.getMonth() + 1).toString().padStart(2, '0')}-${startOfMonth.getDate().toString().padStart(2, '0')}`;
    const rangeEnd = `${endOfMonth.getFullYear()}-${(endOfMonth.getMonth() + 1).toString().padStart(2, '0')}-${endOfMonth.getDate().toString().padStart(2, '0')}`;
    const monthName = startOfMonth.toLocaleString('default', { month: 'long' });
    range[`${monthName} ${startOfMonth.getFullYear()}`] = [rangeStart, rangeEnd];
  }
  return range;
};

